import { Component } from '@angular/core';
import {IonicPage, NavController, ModalController, ViewController, AlertController, App } from 'ionic-angular';

import { Items } from '../../providers/providers';
import { User } from '../../providers/user';
import { Item } from '../../models/item';
import { Client } from '../../models/client';
import { News } from '../../models/news';
import { Alerts } from '../../models/alerts';
import { UserData } from '../../models/user';
import { Assessment } from '../../models/assessment';

@IonicPage({
  name: 'home',
  segment: 'home',
  //priority: 'high'
})
@Component({
  selector: 'page-main-page',
  templateUrl: 'main-page.html'
})
export class MainPage {
  currentItems: Item[];
  currentNews:  News[];
  recentActivities: Alerts[];
  userData: UserData;
  responseData: any;
  parameter1: string;
  assessments: Assessment[];
  page_search: string = '';
  menu_search: string = '';
  show_result: boolean = false;
  displayList: Client[];
  

  constructor(public navCtrl: NavController, public items: Items, public modalCtrl: ModalController,
    public viewCtrl: ViewController, public alertCtrl: AlertController, public user: User,
    //private navParams: NavParams,
    public app: App) {
    this.userData = <UserData>JSON.parse(localStorage.getItem('userData'));
  }
  
  /**
   * The view loaded, let's query our news and recentActivities for the list
   */
  ionViewDidLoad() {
    this.checkVersion();

  }

  checkVersion() {
    // need to set as env variable
    let version = '1.1.6';
    let doNotReload = localStorage.getItem("doNotReload");
    let doNotWarn = localStorage.getItem("doNotWarn");

    this.items.getVersion().subscribe(res => {
      let currentVersion = res.result;

      if (currentVersion !== 'off') {
        if (currentVersion === version) {
          localStorage.removeItem('doNotReload');
          localStorage.removeItem('doNotWarn');
        } else {
          if (doNotReload !== currentVersion) {
            localStorage.setItem('doNotReload', currentVersion);
            window.location.reload();
          } else {
            if (doNotWarn !== currentVersion) {
              localStorage.setItem('doNotWarn', currentVersion);
              const alert = this.alertCtrl.create({
                title: 'Outdated Version!',
                subTitle: 'You are running older version of Novopsych, please clear cache to get the latest version.',
                buttons: ['OK']
              });
              alert.present();
            }
          }
        }
      }

      this.items.getNews(this.userData).subscribe(res => {
        this.currentNews = res.news;
        this.recentActivities = res.alerts;
      },
        err => {
          // Log errors if any
          console.log(err);
        });
        this.items.getAssessmentList().subscribe(res => {
          if (res) {
            this.assessments = res;
            localStorage.setItem('assessments', JSON.stringify(this.assessments));
          }
        }, err => {
          console.error('ERROR', err);
        });
    },
      err => {
        console.log(err);
    });
  }

  administer() {
    let modal = this.modalCtrl.create('ClientPage',{administer: 'administer'});
    modal.present();
  }

  scheduleAssessment(){
    let modal = this.modalCtrl.create('ClientPage',{administer: 'schedule'});
    modal.present();
  }

  emailAssessment(){
    let modal = this.modalCtrl.create('ClientPage',{administer: 'email'});
    modal.present();
  }
  

  cancel() {
    this.viewCtrl.dismiss();
  }

  /**
   * Delete an item from the list of items.
   */
  // deleteItem(item) {
  //   this.items.delete(item);
  // }


  splitTextName(detail){
    if(this.recentActivities.length > 1){
      let stringToSplit = detail;
    let x = stringToSplit.split("has");
    // return x[0] + " " + x[1];
    return x[0];
    }else{
      return detail;
    }
    
  }

  splitTextStatus(detail){
    if(this.recentActivities.length > 1){
    let stringToSplit = detail;
    let x = stringToSplit.split("has");
    // return x[2] + " " + x[3] + " " + x[4] + " " + x[5];
    return "has" + " " + x[1];
    }else{
      return "";
    }
  }

  itemSelected(url: string) {
    var reportId = url.substring(url.lastIndexOf('/') + 1);
    if (reportId) {
      var popup = window.open('', "_blank");
      this.items.getReportURL(reportId).subscribe(data => {
        if (data) {
          popup.location.href = data.url
        }
      },
        error => {
          console.log(error);
        }
      );
    }
  }

  newsSelected(item){
    window.open(item.link,"_blank","location=true");
  }

  logout(){
     localStorage.clear();
     setTimeout(() => this.backToWelcome(), 1000);
}

backToWelcome(){
   const root = this.app.getRootNav();
   root.popToRoot();
}

goToClientsPage(){
  this.navCtrl.push('clients');
}

goToHomePage(){
  this.navCtrl.push('home');
}

goToAssessmentsPage(){
  this.navCtrl.push('assessments');
}

goToInsightPage() {
  window.open('redirect-insights', "_blank");
  // this.navCtrl.push('redirect-insights');
}

goToAccountsPage(){
  this.navCtrl.push('account');
}

selectClient(item) {
  this.navCtrl.push('clients', { clientId: item.id, client: item })

}

onInput() {
  var menu_search = this.menu_search.trim()

  if (menu_search.length < 3) {
    this.displayList = [];
    this.show_result = false;
  } else {      
    this.items.getClientSmallList(this.menu_search).subscribe(res => {
      if (res) {
        this.displayList = res;
        this.show_result = true;
        return this.displayList;
        }
    }, err => {
      console.error('ERROR', err);
    });
  }    
}

  
}



// WEBPACK FOOTER //
// ./src/pages/main-page/main-page.ts